<div id="garminWidgety" class="garminwidget" [class]="activity.type.toLowerCase()">
    <div style="width:100%;display:inline-block">
      <p class="topLine">{{activity.name}}</p>
      <ion-icon style="float:right;margin-top:7px" name="bar-chart"></ion-icon>
    </div>
    <div style="display:flex">
      <div style="display: flex;
      pointer-events: none;
      min-width: 46vw;
      min-height: 24vw;">
        <app-polyline-map [mapId]="mapId" *ngIf="activity.map?.polyline||activity.map?.summary_polyline" [polyline]="activity.map?.summary_polyline" [type]="activity.type"></app-polyline-map>
        <h1 class="garminDistance" *ngIf="activity.distance>0">{{activity.distance | distance :'show' }}</h1>
        <h1 class="garminDistance" style="padding:0;margin:auto;position:relative" *ngIf="activity.distance === 0">{{activityMinutes}}</h1>
      </div>
      <table class="garminTable">
        <tr>
          <td class="columnDark">Time</td>
          <td class="columnWhite">{{activity.moving_time | elapsed}}</td>
        </tr>
        <tr *ngIf="activity.distance>0">
          <td class="columnDark">Pace</td>
          <td class="columnWhite">{{activity.pace | elapsed}}</td>
        </tr>
        <tr *ngIf="activity.total_elevation_gain">
          <td class="columnDark" >Total ascend</td>
          <td class="columnWhite">{{activity.total_elevation_gain}}</td>
        </tr>
        <tr *ngIf="activity.average_heartrate">
          <td class="columnDark" *ngIf="activity.average_heartrate">AVG HR</td>
          <td class="columnWhite">{{activity.average_heartrate | number: '1.0-0'}}</td>
        </tr>
      </table>
    </div>
  </div>
